import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57509004&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57509004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57509004')) {
      api.createRecord('57509004', component.options)
    } else {
      api.reload('57509004', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57509004&scoped=true&", function () {
      api.rerender('57509004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/index.vue"
export default component.exports